import {
    Button,
    Menu,
    MenuContent,
    MenuSeparator,
    MenuTrigger,
    MenuRadioItem,
    MenuRadioGroup,
} from '@cad-arc';
import './group-styling.css';
import { WorkspaceQueueDto } from '@mark43/cad-api';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { WorkspaceQueue } from '../../panels/workspace-queue';
import { UnitQueueStore } from '../../unit-queues/store/unit-queue-store';
import { useQueueStore } from '../context/use-queue-store';
import { useAvailableColumns } from '../hooks/use-available-columns';
import { useColumnDisplayNames } from '../hooks/use-column-display-names';

export const QueueGroupByMenu = observer(function QueueGroupByDropdown(): React.ReactElement {
    const MAX_GROUP_BY_MENU_HEIGHT = '500px';
    const MIN_GROUP_BY_MENU_HEIGHT = '398px';
    const queueStore = useQueueStore() as UnitQueueStore;
    const columnDisplayNames = useColumnDisplayNames();
    const groupColumn = queueStore.workspacePanel.queue.groupByQueueColumnDefinition;
    const availableColumns = useAvailableColumns();
    const [maximumHeight, setMaximumHeight] = useState(
        groupColumn ? MIN_GROUP_BY_MENU_HEIGHT : MAX_GROUP_BY_MENU_HEIGHT
    );
    return (
        <>
            <Menu>
                <MenuTrigger asChild>
                    <Button trailingVisual={groupColumn ? undefined : 'Open'} variant="ghost">
                        <>
                            Group
                            {groupColumn && (
                                <span>{`: ${columnDisplayNames[groupColumn].displayName}`}</span>
                            )}
                        </>
                    </Button>
                </MenuTrigger>
                <MenuContent
                    data-testid="queue-group-by-menu"
                    style={{ paddingRight: '0', minWidth: '205px' }}
                >
                    <MenuRadioGroup
                        title="Group By"
                        onValueChange={(value: string) => {
                            if (groupColumn === undefined || value !== groupColumn) {
                                setMaximumHeight(MIN_GROUP_BY_MENU_HEIGHT);
                            } else {
                                setMaximumHeight(MAX_GROUP_BY_MENU_HEIGHT);
                            }
                            queueStore.setGroupByQueueColumnDefinition(
                                value as WorkspaceQueueDto['groupByQueueColumnDefinition']
                            );
                        }}
                        value={queueStore.workspacePanel.queue.groupByQueueColumnDefinition}
                    >
                        <div
                            className="custom-scrollbar"
                            style={{
                                maxHeight: maximumHeight,
                                overflowY: 'auto',
                            }}
                        >
                            {availableColumns
                                .filter((column) => column.groupable)
                                .map((column) => (
                                    <MenuRadioItem key={column.name} value={column.name}>
                                        {columnDisplayNames[column.name].displayName}
                                    </MenuRadioItem>
                                ))}
                        </div>
                    </MenuRadioGroup>

                    {groupColumn && (
                        <>
                            <MenuSeparator />
                            <MenuRadioGroup
                                title="Sort Direction"
                                onValueChange={(value: string) => {
                                    queueStore.setGroupBySortDirection(
                                        value as WorkspaceQueue['sortDirection']
                                    );
                                }}
                                value={queueStore.workspacePanel.queue.groupBySortDirection}
                            >
                                <MenuRadioItem value="REGULAR_ASCENDING">
                                    Sort Ascending
                                </MenuRadioItem>
                                <MenuRadioItem value="REGULAR_DESCENDING">
                                    Sort Descending
                                </MenuRadioItem>
                            </MenuRadioGroup>
                        </>
                    )}
                </MenuContent>
            </Menu>
        </>
    );
});
